import type { CSSProperties, ReactNode } from 'react';
import { cx } from '@/lib/cx';
import styles from './Card.module.css';

interface CardProps {
  children: ReactNode;
  /** Left accent bar — credit rows are sky-deep, settled rows navy. */
  accent?: string;
  accentWidth?: number;
  elevated?: boolean;
  className?: string;
  style?: CSSProperties;
}

/** The standard white surface: 1px light border, soft navy-tinted shadow. */
export function Card({
  children,
  accent,
  accentWidth = 4,
  elevated = false,
  className,
  style,
}: CardProps) {
  return (
    <div
      className={cx(styles.card, elevated && styles.elevated, className)}
      style={{
        ...(accent ? { borderLeft: `${accentWidth}px solid ${accent}` } : null),
        ...style,
      }}
    >
      {children}
    </div>
  );
}
